var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2413 2.9915L12.366 1.86616C12.6005 1.63171 12.9184 1.5 13.25 1.5C13.5816 1.5 13.8995 1.63171 14.134 1.86616C14.3685 2.10062 14.5002 2.4186 14.5002 2.75016C14.5002 3.08173 14.3685 3.39971 14.134 3.63416L7.05467 10.7135C6.70222 11.0657 6.26758 11.3246 5.79 11.4668L4 12.0002L4.53333 10.2102C4.67552 9.73259 4.93442 9.29795 5.28667 8.9455L11.2413 2.9915ZM11.2413 2.9915L13 4.75016M12 9.3335V12.5002C12 12.898 11.842 13.2795 11.5607 13.5608C11.2794 13.8421 10.8978 14.0002 10.5 14.0002H3.5C3.10218 14.0002 2.72064 13.8421 2.43934 13.5608C2.15804 13.2795 2 12.898 2 12.5002V5.50016C2 5.10234 2.15804 4.72081 2.43934 4.4395C2.72064 4.1582 3.10218 4.00016 3.5 4.00016H6.66667",
    stroke: "#1E073A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit2);
export default __webpack_public_path__ + "static/media/edit-2.5f7edc1c66cbf57a2e95278f78787081.svg";
export { ForwardRef as ReactComponent };